import React from "react";
import MuiDialogActions from '@material-ui/core/DialogActions';


export default function DialogActions(props){
    const {...rest} =props;
    return (<MuiDialogActions {...rest}/>)
}